import * as types from './mutation-types';
const mutations = {
  [types.SET_SELECT_LIST](state, newList) {
    state.selectList = newList;
  },
  [types.DEL_SELECT_LIST](state, id) {
    const index = state.selectList.findIndex((item) => item.patientId === id);
    state.selectList.splice(index, 1);
  },
  [types.SET_PATIENT_LIST](state, newList) {
    state.patientList = newList;
  },
  [types.DEL_PATIENT_LIST](state, id) {
    const index = state.patientList.findIndex((item) => item.patientId === id);
    state.patientList.splice(index, 1);
  },
  [types.SET_SELECT_PATIENT_ID](state, id) {
    state.selectPatientId = id;
  },
  [types.SET_PATIENT_COUNT](state, count) {
    state.count = count;
  },
  [types.SET_LOADING](state, status) {
    state.loading = status;
  },
  [types.SWITCH_TAB_INDEX](state, index) {
    state.currentTabIndex = index;
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize;
  },
  [types.SET_CURRENT_PAGE](state, currentPage) {
    state.currentPage = currentPage;
  },
  [types.SET_PATIENT_NAME](state, name) {
    state.patientName = name;
  },
  [types.SET_FAVOURITE](state, status) {
    state.favorite = status;
  },
  [types.SET_QUERY](state, query) {
    state.query = query;
  },
  [types.SET_SHOW_HEADER](state, bool) {
    state.showHeader = bool;
  },
  [types.SET_CURRENT_ROUTER](state, val) {
    state.currentRouter = val;
  },
  [types.SET_SEARCH_CONDITION](state, patientName) {
    state.patientName = patientName;
  },
  [types.SET_VISIT_PATIENT_LIST](state, newList) {
    state.visitPatientList = newList;
  },
  [types.SET_VISIT_PATIENT_COUNT](state, count) {
    state.visitCount = count;
  },
  [types.SET_PREINQUIRY_PATIENT_LIST](state, newList) {
    state.preInquiryPatientList = newList;
  },
  [types.SET_PREINQUIRY_PATIENT_COUNT](state, count) {
    state.preInquiryPatientCount = count;
  },
  [types.SET_IMPORT_SELECT_LIST](state, newList) {
    state.importSelectList = newList;
  },
  [types.SET_VISIT_SELECT_LIST](state, newList) {
    state.visitSelectList = newList;
  },
  [types.SET_REPORT_LOADING](state, status) {
    state.reportLoading = status;
  },
  [types.SET_CHECK_REPORT_RIGHT_LOADING](state, status) {
    state.checkReportRightLoading = status;
  },
  [types.SET_LOCATION_INFO](state, res) {
    state.provinceList = res.provinceList || [];
  },
  [types.SET_ISSUE_FORM_PATIENT_LIST](state, newList) {
    state.issueFormPatientList = newList;
  },
  [types.SET_ISSUE_FORM_PATIENT_COUNT](state, count) {
    state.issueFormCount = count;
  },
  [types.SET_CURRENT_OUT_CALL_PATIENT](state, patientItem) {
    state.currentOutCallPatient = patientItem;
  },
  [types.SET_OUT_CALL_COMPONENT_SHOW](state, bool) {
    state.outCallComponentShow = bool;
  },
  [types.SET_OUT_CALLING](state, bool) {
    state.outCallIng = bool;
  },
  [types.SET_OUT_CALL_ROUTER](state, outCallPatientRouter) {
    state.outCallRouter = outCallPatientRouter;
  },
  [types.SET_IN_HOSPITAL_SELECT_LIST](state, newList) {
    state.inHospitalSelectList = newList;
  },
  [types.DEL_IN_HOSPITAL_SELECT_LIST](state, id) {
    const index = state.inHospitalSelectList.findIndex((item) => item.patientId === id);
    state.inHospitalSelectList.splice(index, 1);
  },
  [types.SET_IN_HOSPITAL_FOCUS_SELECT_LIST](state, newList) {
    state.inHospitalFocusSelectList = newList;
  },
  [types.DEL_IN_HOSPITAL_FOCUS_SELECT_LIST](state, id) {
    const index = state.inHospitalFocusSelectList.findIndex((item) => item.patientId === id);
    state.inHospitalFocusSelectList.splice(index, 1);
  },
  [types.SET_PREINQUIRY_VISITID](state, val) {
    state.preInquiryVisitId = val;
  },
  [types.SET_REMINDSUM](state, val) {
    state.remindSum = val;
  },
  [types.SET_ORGANTYPE](state, val) {
    state.organType = val;
  },
  [types.SET_TAGFILTERSELECTEDLIST](state, val) {
    state.tagFilterSelectedList = val;
  },
  [types.SET_TAG_INFO_LOADING](state, status) {
    state.tagInfoLoading = status;
  },
  // 家医模块相关mutations
  [types.SET_FAMILY_DOCTOR_SELECT_LIST](state, newList) {
    state.familyDoctorSelectList = newList;
  },
  [types.DEL_FAMILY_DOCTOR_SELECT_LIST](state, id) {
    const index = state.familyDoctorSelectList.findIndex(item => item.residentId === id);
    state.familyDoctorSelectList.splice(index, 1);
  },
};
export default mutations;
